import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "6:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-1-mode.png`,
        },
      },
    },
  },
  "6:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-2-modes.png`,
        },
      },
    },
  },
  "6:3": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-3-modes.png`,
        },
      },
    },
  },
  "6:4": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-4-modes.png`,
        },
      },
    },
  },
  "6:5": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-5-modes.png`,
        },
      },
    },
  },
  "6:6": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-6-modes.png`,
        },
      },
    },
  },
};

export default components;
